export class AppConfig {
    // Note: some duplication here with server properties
    // But want to avoid an HTTP request just to provide these settings
    static readonly PublicFilesPath = 'public';
    static readonly AvatarImagesPath = AppConfig.PublicFilesPath + '/images/avatar';
    static readonly AvatarImageMaxSize = 100 * 1024;
    static readonly AvatarImageAcceptedExtensions = ['jpg', 'jpeg', 'png', 'gif'];
}